import { access, injectReducers } from '@driftt/traffic-control'
import { not } from 'ramda'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import FeedbackModal from 'components/EditorNavigation/FeedbackModal'
import { trackEvent } from 'utils/tracking'

const ContentViewLayout = ({
  pbId,
  isTestMode = false,
  isExperiment = false,
}) => {
  const [topologyLoadReady, setTopologyLoadReady] = useState(false)
  const [TopologyMod, setTopologyMod] = useState(null)
  const [initialRender, setInitialRender] = useState(false)
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false)
  const orgId = useSelector((state) => state.org.id)
  const user = useSelector((state) => state.user)
  const orgUsers = useSelector((state) => state.org.users)
  const pageVisitTracked = useRef(false)

  const openFeedbackModal = useCallback(
    () => setIsFeedbackModalOpen(not(isFeedbackModalOpen)),
    [isFeedbackModalOpen]
  )

  useEffect(() => {
    !TopologyMod &&
      import('@driftt/magnus-topology').then((mod) => {
        injectReducers(mod.TopologyReducer)
        setTopologyMod(mod.TopologyWrapper)
      })
    TopologyMod && setTopologyLoadReady(true)
    TopologyMod && setTimeout(() => setInitialRender(true), 0)
  }, [TopologyMod])

  if (!pbId || !topologyLoadReady || !initialRender) {
    return null
  }

  if (!pageVisitTracked.current) {
    pageVisitTracked.current = true
    trackEvent('Playbook Content View Page Visit', {
      orgId,
      user,
    })
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <TopologyMod
        pbId={pbId}
        isTestMode={isTestMode}
        isExperiment={isExperiment}
        onGiveBetaFeedback={openFeedbackModal}
        user={user}
        orgId={orgId}
        orgUsers={orgUsers}
        hasRequiredGates={access.hasGates('collab_commenting')}
      />
      <FeedbackModal open={isFeedbackModalOpen} onClose={openFeedbackModal} />
    </div>
  )
}

export default ContentViewLayout
